import React from 'react'

/**
 * Header for the indicators column. Static label — the active-filter count and
 * clear affordance live in the filter bar, not the column header.
 */
export const IndicatorsHeader = (): React.ReactNode => 'Indicators'

IndicatorsHeader.displayName = 'IndicatorsHeader'
